import { render, staticRenderFns } from "./Paginaton.vue?vue&type=template&id=9e86d208&"
import script from "./Paginaton.vue?vue&type=script&lang=js&"
export * from "./Paginaton.vue?vue&type=script&lang=js&"
import style0 from "./Paginaton.vue?vue&type=style&index=0&id=9e86d208&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports